import type {
  Company,
  Department,
  DepartmentTreeNode,
  Position,
} from "@evolua/api-client";

const COMPANIES: Company[] = [
  {
    id: "aaaaaaaa-aaaa-4aaa-8aaa-aaaaaaaaaaaa",
    parentId: null,
    legalName: "Acme Tecnologia Ltda",
    tradeName: "Acme Matriz",
    cnpj: "12.345.678/0001-90",
    externalId: "1",
    provider: "FAKE_CORE",
    syncedAt: "2026-08-11T12:00:00.000Z",
    employeeCount: 3,
    integrations: [
      {
        id: "99999999-9999-4999-8999-999999999901",
        provider: "FAKE_CORE",
        status: "HEALTHY",
        baseUrl: "https://fake-core.demo.local",
      },
    ],
  },
  {
    id: "ffffffff-ffff-4fff-8fff-ffffffffffff",
    parentId: "aaaaaaaa-aaaa-4aaa-8aaa-aaaaaaaaaaaa",
    legalName: "Acme Tecnologia Filial SP",
    tradeName: "Acme Filial SP",
    cnpj: "12.345.678/0002-71",
    externalId: "2",
    provider: "FAKE_CORE",
    syncedAt: "2026-08-11T12:00:00.000Z",
    employeeCount: 1,
    integrations: [],
  },
];

const DEPARTMENTS: Department[] = [
  {
    id: "bbbbbbbb-bbbb-4bbb-8bbb-bbbbbbbbbbbb",
    companyId: "aaaaaaaa-aaaa-4aaa-8aaa-aaaaaaaaaaaa",
    parentId: null,
    code: "RH",
    name: "RH",
    externalId: "RH",
    provider: "FAKE_CORE",
    syncedAt: "2026-08-11T12:00:00.000Z",
    employeeCount: 1,
    depth: 0,
    childCount: 0,
  },
  {
    id: "cccccccc-cccc-4ccc-8ccc-cccccccccccc",
    companyId: "aaaaaaaa-aaaa-4aaa-8aaa-aaaaaaaaaaaa",
    parentId: null,
    code: "OPS",
    name: "Operações",
    externalId: "OPS",
    provider: "FAKE_CORE",
    syncedAt: "2026-08-11T12:00:00.000Z",
    employeeCount: 1,
    depth: 0,
    childCount: 1,
  },
  {
    id: "cccccccc-cccc-4ccc-8ccc-cccccccccc01",
    companyId: "aaaaaaaa-aaaa-4aaa-8aaa-aaaaaaaaaaaa",
    parentId: "cccccccc-cccc-4ccc-8ccc-cccccccccccc",
    code: "OPS-CAMPO",
    name: "Operações — Campo",
    externalId: "OPS-CAMPO",
    provider: "FAKE_CORE",
    syncedAt: "2026-08-11T12:00:00.000Z",
    employeeCount: 0,
    depth: 1,
    childCount: 0,
  },
  {
    id: "dddddddd-dddd-4ddd-8ddd-dddddddddddd",
    companyId: "aaaaaaaa-aaaa-4aaa-8aaa-aaaaaaaaaaaa",
    parentId: null,
    code: "FIN",
    name: "Financeiro",
    externalId: "FIN",
    provider: "FAKE_CORE",
    syncedAt: "2026-08-11T12:00:00.000Z",
    employeeCount: 1,
    depth: 0,
    childCount: 0,
  },
];

const POSITIONS: Position[] = [
  {
    id: "eeeeeeee-eeee-4eee-8eee-eeeeeeeeeeee",
    code: "ANL",
    name: "Analista",
    cbo: "2521-05",
    externalId: "ANL",
    provider: "FAKE_CORE",
    syncedAt: "2026-08-11T12:00:00.000Z",
    employeeCount: 2,
  },
  {
    id: "eeeeeeee-eeee-4eee-8eee-eeeeeeeeeee1",
    code: "CRD",
    name: "Coordenador",
    cbo: "1421-05",
    externalId: "CRD",
    provider: "FAKE_CORE",
    syncedAt: "2026-08-11T12:00:00.000Z",
    employeeCount: 1,
  },
  {
    id: "eeeeeeee-eeee-4eee-8eee-eeeeeeeeeee2",
    code: "BP",
    name: "Business Partner",
    cbo: null,
    externalId: "BP",
    provider: "FAKE_CORE",
    syncedAt: "2026-08-11T12:00:00.000Z",
    employeeCount: 1,
  },
];

export function listDemoCompanies(): { data: Company[] } {
  return { data: COMPANIES };
}

export function getDemoCompany(id: string): Company {
  const row = COMPANIES.find((c) => c.id === id);
  if (!row) throw new Error("Empresa não encontrada (demo)");
  return row;
}

export function listDemoDepartments(companyId?: string): { data: Department[] } {
  const data = companyId
    ? DEPARTMENTS.filter((d) => d.companyId === companyId)
    : DEPARTMENTS;
  return { data };
}

export function getDemoDepartmentTree(companyId?: string): {
  data: DepartmentTreeNode[];
} {
  const all = listDemoDepartments(companyId).data;
  const build = (parentId: string | null): DepartmentTreeNode[] =>
    all
      .filter((d) => d.parentId === parentId)
      .map((d) => ({
        id: d.id,
        name: d.name,
        code: d.code,
        employeeCount: d.employeeCount,
        children: build(d.id),
      }));
  return { data: build(null) };
}

export function getDemoDepartment(id: string): Department {
  const row = DEPARTMENTS.find((d) => d.id === id);
  if (!row) throw new Error("Departamento não encontrado (demo)");
  return row;
}

export function listDemoPositions(): { data: Position[] } {
  return { data: POSITIONS };
}

export function getDemoPosition(id: string): Position {
  const row = POSITIONS.find((p) => p.id === id);
  if (!row) throw new Error("Cargo não encontrado (demo)");
  return row;
}
